import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { Avatar, AvatarGroup } from '@sketchnote/shared-components';
import { Radio } from '@sketchnote/shared-components';
import { Dispatch, SetStateAction, useState } from 'react';

import { useBoardStore } from '../store/useBoardStore';

export interface QuickFilterAssigneeProps {
  name: string;
  memberId: string;
  avatar: string;
}
export const QuickFilterAssignee = ({
  assigneeOptions,
  quickFilterAssignee,
  setQuickFilterAssignee,
}: {
  assigneeOptions: QuickFilterAssigneeProps[];
  quickFilterAssignee: string;
  setQuickFilterAssignee: Dispatch<SetStateAction<string>>;
}) => {
  const boardsStore = useBoardStore();

  const handleFilterClick = (filteredMemberId: string) => {
    setQuickFilterAssignee(filteredMemberId);
    boardsStore.onAddQuickFilter('assignee', filteredMemberId);
  };
  const [showDropdrown, setShowDropdrown] = useState(false);

  const handleClosePopover = () => {
    setShowDropdrown(false);
  };
  const handleRadioButtonChange = async (event) => {
    setQuickFilterAssignee(event.target.value);
    boardsStore.onAddQuickFilter('assignee', event.target.value);
    setShowDropdrown(false);
  };

  return (
    <div className="flex items-center pl-10">
      <AvatarGroup maxCount={4} className="items-center my-auto">
        {assigneeOptions.map((memberInfo, index) => (
          <button
            key={`${memberInfo.memberId}-${index}`}
            onClick={() => handleFilterClick(memberInfo.memberId)}
            className=""
          >
            <Avatar
              size="sm1"
              name={memberInfo.name}
              type={memberInfo.avatar ? 'photo' : 'initials'}
              src={memberInfo.avatar}
              wrapperClassName={`border-2 transform transition duration-500 hover:scale-125 -mr-8 ${
                quickFilterAssignee === memberInfo.memberId &&
                assigneeOptions.findIndex((item) => item.memberId === memberInfo.memberId) > -1 &&
                assigneeOptions.findIndex((item) => item.memberId === memberInfo.memberId) < 4
                  ? 'border-blue-500 transform transition duration-500 scale-125 z-10'
                  : 'border-white'
              }`}
            />
          </button>
        ))}
      </AvatarGroup>
      {assigneeOptions.length > 4 && (
        <Popover
          placement="right-start"
          offset={[28, -10]}
          isOpen={showDropdrown}
          onClose={handleClosePopover}
        >
          <PopoverTrigger>
            <button onClick={() => setShowDropdrown(true)}>
              <Avatar
                size="sm1"
                name={assigneeOptions.length - 4}
                tooltip={false}
                type={'initials'}
                src={''}
                wrapperClassName="-ml-18 border-1 border-white  transform transition duration-500 hover:scale-125"
              />
            </button>
          </PopoverTrigger>
          <Portal>
            <PopoverContent>
              <div
                className="mt-10 shadow-md rounded-md"
                style={{
                  maxHeight: '300px',
                  width: '220px',
                  overflow: 'auto',
                }}
              >
                {assigneeOptions.map((option, index) => {
                  const isAdded = quickFilterAssignee === option.memberId;
                  return (
                    <div
                      key={`{${option.memberId}-${index}}`}
                      className="flex gap-8 px-10 h-40 items-center min-w-200 bg-white"
                    >
                      <Radio
                        className="text-gray-600 font-regular text-xs leading-16"
                        innerClassName=""
                        value={option.memberId}
                        name={option.name}
                        checked={isAdded}
                        onChange={handleRadioButtonChange}
                      />
                      <img
                        src={option.avatar}
                        alt={option.name}
                        className="h-20 w-20 rounded-full object-cover flex-shrink-0"
                        style={{ border: '1px solid #D5D7DD' }}
                      />
                      <p className="text-sm font-regular text-gray-999 leading-20 flex-grow truncate">
                        {option.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            </PopoverContent>
          </Portal>
        </Popover>
      )}
    </div>
  );
};
